import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ffffff',
    },
    background: {
      default: 'transparent',
      paper: 'rgba(18, 18, 18, 0.8)',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b3b3b3',
    }
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-root': {
            resize: 'vertical',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          },
          '& .MuiInputBase-inputMultiline': {
            flex: '1 1 auto',
            overflow: 'auto'
          }
        }
      }
    }
  }
});

let root = null;

// Create a function to initialize the app
window.initActionVerbsApp = (containerId) => {
  const container = document.getElementById(containerId);
  if (container) {
    // If root exists, just render to it
    if (root) {
      root.render(
        <React.StrictMode>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </React.StrictMode>
      );
    } else {
      // Create new root only if it doesn't exist
      root = ReactDOM.createRoot(container);
      root.render(
        <React.StrictMode>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </React.StrictMode>
      );
    }
  }
};

// Initialize immediately in development only
if (process.env.NODE_ENV === 'development') {
  const container = document.getElementById('action-verbs-app');
  if (container && !root) {
    root = ReactDOM.createRoot(container);
    root.render(
      <React.StrictMode>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </React.StrictMode>
    );
  }
}
